// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1COiQ","cell":"ColumnAccessor_cell__45zxD","firstCellAccent":"ColumnAccessor_firstCellAccent__1xDuJ"};